// Projects

// Gifs 

export const POPUmai = require('./pop.gif');
export const Platello = require('./platello.gif');
export const TechBlog = require('./techblog.gif');
export const QuizCode = require('./quiz.gif');
export const PassGen = require('./pass-gen.gif');

// PNGS

export const Makullveny = require('./makullveny.png');
export const TeamGenerator = require('./teamGenerator.png');
export const NoteTaker = require('./note-taker.png');
export const EComBackend = require('./e-commerce-backend.png');
export const ReadMeGen = require('./readme-gen.png');
export const WeatherApp = require('./weather-site.png');
export const MyTodos = require('./my-todos.png');
export const CalenderApp = require('./my-calender-app.png');
export const RpsGame = require('./rps.png');